import { IConfig } from '@vivli/shared/infrastructure/interface';
import { useStorage } from '@vivli/shared/infrastructure/hook';

export const useB2CAuthority = (config: IConfig, policyName?: string): string => {
    const { getItem, setItem } = useStorage();
    const storedPolicyName = getItem('policyName');

    const policy = policyName || storedPolicyName || config?.b2CSignInPolicyName;

    setItem('policyName', policy);

    const b2cName = config?.b2CTenant.split('.')[0];

    return `https://${b2cName}.b2clogin.com/${config?.b2CTenant}/${policy}`;
};
